import { render, staticRenderFns } from "./ItemSize.vue?vue&type=template&id=4d2dd532"
import script from "./ItemSize.vue?vue&type=script&lang=js"
export * from "./ItemSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports